import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export const ReportAppendixA = ({ data, month }) => {
  useNavigate();

  const columns = [
    { id: "sl_no", label: "Sl. No." },
    { id: "school_name", label: "School Name" },
    { id: "total_usage_till_last_month", label: "Total Usage" },
    { id: "total_usage_curr_month", label: "Total Usage" },
  ];

  return (
    <div className="report-appendixA-container">
      <Typography
        sx={{
          fontSize: "35px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "30px",
        }}
      >
        Appendix A: Active School Usage Report
      </Typography>
      <TableContainer component={Paper} className="table m-1 mt-4">
        <Table id="summary" className="mb-0">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id}>
                  {column.label}
                  {column.id === "total_usage_till_last_month" && (
                    <Typography variant="body1" sx={{ fontSize: "10px" }}>
                      (Till {month.prev_month})<br />
                      (Hours)
                    </Typography>
                  )}
                  {column.id === "total_usage_curr_month" && (
                    <Typography variant="body1" sx={{ fontSize: "10px" }}>
                      (Till now)
                      <br />
                      (Hours)
                    </Typography>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.values(data.school_wise_usage_report).map((row, index) => {
              const growth = Math.ceil(
                ((Math.ceil(row.total_usage / 60) -
                  Math.ceil(row.usage_till_last_month / 60)) /
                  Math.ceil(row.usage_till_last_month / 60)) *
                  100
              );
              return (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.school_name}</TableCell>
                  <TableCell>
                    {Math.ceil(row.usage_till_last_month / 60)}
                  </TableCell>
                  <TableCell>
                    {Math.ceil(row.total_usage / 60)}
                    <span className="text-green-500 text-xs">
                      {"  "}
                      {growth > 0 ? `+${growth}%` : ""}
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
